/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/fr.js'

import iconSet from 'quasar/icon-set/material-icons.js'



import {Notify,Cookies,AddressbarColor,SessionStorage,Dialog,LocalStorage,Loading,Dark} from 'quasar'



export default { config: {"loading":{},"notify":{},"loadingBar":{"skipHijack":false,"position":"top","color":"primary","size":"2px"}},lang,iconSet,plugins: {Notify,Cookies,AddressbarColor,SessionStorage,Dialog,LocalStorage,Loading,Dark} }

